import { useEffect, useState } from 'react'
import { Route, Routes } from 'react-router'
import { inject, observer, Provider } from 'mobx-react'
import posed, { PoseGroup } from 'react-pose'
import { withRouterProps } from '../../utils'
import OnboardingStore from './OnboardingStore'
import AcceptTerms from './accept-terms/AcceptTerms'
import AccountInfo from './account-info/AccountInfo'
import ProfileInfo from './account-info/ProfileInfo'
import AccountInfoMore from './account-info-more/AccountInfoMore'
import SpouseInfo from './spouse-info/SpouseInfo'
import FirstSSIPage from './social-security-income/FirstSSIPage'
import SecondSSIPage from './social-security-income/SecondSSIPage'
import Pension from '../onboarding/pension/Dashboard'
import DependentsInfo from './dependents-info/DependentsInfo'
import ContactInfo from './contact-info/ContactInfo'
import AccumOrSpend from './accumulating-or-spending/AccumulatingOrSpending'
import Greeting from './welcome-greeting/WelcomeGreeting'
import IncomeGoal from './income-goal/IncomeGoal'
import ReacceptTerms from './reaccept-terms/ReacceptTerms'
import NewChanges from './welcome-new-changes/NewChanges'
import { Loading } from '../../components'
import { Page, NotFound } from './elements'
import { Header } from './elements/Page'
import { useTheme } from '@emotion/react'

const RouteContainer = posed.div({
  enter: { opacity: 1, delay: 300, beforeChildren: true },
  exit: { opacity: 0 },
})

function Onboarding(props) {
  const [onboarding] = useState(() =>
    OnboardingStore.create({ status: 'loading' }, { store: props.store })
  )
  const { features } = onboarding
  const { location } = props
  const { isRetail } = props.store.config
  const theme = useTheme()

  useEffect(() => {
    onboarding.setTheme(theme)
    document.documentElement.setAttribute('class', onboarding.background)
    return () => {
      document.documentElement.className = ''
      onboarding.setTheme(null)
    }
  })

  return (
    <Provider onboarding={onboarding}>
      <Page.Container>
        <Header />
        {onboarding.status === 'loading' && <Loading />}

        {onboarding.status === 'error' && (
          <Page.ErrorMessage>Oops! Something went wrong, please try again later</Page.ErrorMessage>
        )}

        {onboarding.status === 'done' && (
          <PoseGroup animateOnMount>
            <RouteContainer key={location.key || location.pathname}>
              <Routes location={location}>
                <Route path='/reaccept-terms' element={<ReacceptTerms />} />

                {features.enableGoals && <Route path='/income-goal' element={<IncomeGoal />} />}

                <Route path='/saving-or-spending' element={<AccumOrSpend />} />
                <Route path='/greeting' element={<Greeting />} />

                {(features.enableMobilePhone || isRetail) && (
                  <Route path='/contact-info' element={<ContactInfo />} />
                )}

                {features.enableDependents && (
                  <Route path='/dependents' element={<DependentsInfo />} />
                )}

                {features.enableSpouse && <Route path='/spouse' element={<SpouseInfo />} />}

                <Route path='/social-security-income' element={<FirstSSIPage />} />
                <Route path='/social-security-income/2' element={<SecondSSIPage />} />
                <Route path='/pension-options' element={<Pension />} />

                {features.enableOtherIncome && (
                  <Route path='/account-continued' element={<AccountInfoMore />} />
                )}

                <Route
                  path='/account'
                  element={features.enablePreferredName ? <AccountInfo /> : <ProfileInfo />}
                />

                <Route path='/new-changes' element={<NewChanges />} />
                <Route path='/accept-terms' element={<AcceptTerms />} />

                <Route path='*' element={<NotFound />} />
              </Routes>
            </RouteContainer>
          </PoseGroup>
        )}
      </Page.Container>
    </Provider>
  )
}

export default withRouterProps(inject('store')(observer(Onboarding)))
